import { adServerClients } from '../constants/constants';

export const cleanString = (str) => {
  return str.replace(/ /g, '').toLowerCase();
};

export const determineAdServer = (bannerData) => {
  if (bannerData?.banner?.flightId) {
    return adServerClients.KEVEL;
  }
  return undefined;
};
